
import AppDetails from './AppDetails';

export default AppDetails;
